/**
 * Configuration de la balance (RS-232 via adaptateur USB↔RS232)
 *
 * BAXTRAN SL - Spécifications:
 * - Protocole: RS232
 * - Baud Rate: 9600 bauds
 * - Format: 8N1 (8 data bits, No parity, 1 stop bit)
 * - Sortie: ASCII avec poids, unité (g/kg) et statut stabilité (S/U)
 */

export type ScaleConfig = {
  /** macOS: /dev/cu.usbserial-XXXX (⚠️ prefix 'cu.' recommandé, pas 'tty.') */
  port_name: string;
  /** 9600 pour BAXTRAN SL (ancien: 4800) */
  baud_rate: number;
  /** Data bits: 8 pour BAXTRAN SL */
  data_bits: 8 | 7 | 6 | 5;
  /** Parity: None pour BAXTRAN SL */
  parity: 'none' | 'even' | 'odd';
  /** Stop bits: 1 pour BAXTRAN SL */
  stop_bits: 1 | 2;
  /** Flow control: None pour BAXTRAN SL */
  flow_control: 'none' | 'hardware';
  /** Unité annoncée par la balance (si "g", on convertit en kg) */
  unit: 'kg' | 'g';
  /** Valider automatiquement quand stable */
  auto_confirm: boolean;
};

/** Valeurs par défaut pour BAXTRAN SL (tu pourras les surcharger via tes réglages) */
export const DEFAULT_SCALE_CONFIG: ScaleConfig = {
  port_name: '/dev/cu.usbserial-B003CO2S', // À adapter selon le port détecté
  baud_rate: 9600, // BAXTRAN SL utilise 9600 bauds (8N1)
  data_bits: 8,
  parity: 'none',
  stop_bits: 1,
  flow_control: 'none',
  unit: 'g',
  auto_confirm: true,
};

/**
 * Configuration Web Serial API pour BAXTRAN SL
 * Compatible avec navigator.serial (frontend)
 */
export const WEB_SERIAL_CONFIG: SerialOptions = {
  baudRate: 9600,
  dataBits: 8,
  parity: 'none',
  stopBits: 1,
  flowControl: 'none',
};

/**
 * Filtres USB pour détecter automatiquement la balance
 * FTDI est le chipset commun pour les adaptateurs USB-RS232
 */
export const USB_FILTERS: SerialPortFilter[] = [
  { usbVendorId: 0x0403 }, // FTDI (chipset utilisé par l'adaptateur USB-RS232)
  { usbVendorId: 0x067b }, // Prolific
  { usbVendorId: 0x10c4 }, // Silicon Labs CP210x
];
